export const ErrorCodes = {
	INTERNAL_ERROR: 'INTERNAL_ERROR',
	ICE_ERROR: 'ICE_ERROR',
	VALIDATION_ERROR: 'VALIDATION_ERROR',
	QUOTE_MISMATCH: 'QUOTE_MISMATCH',
	QUOTE_LOCKED: 'QUOTE_LOCKED',
	QUOTE_DECLINED: 'QUOTE_DECLINED',
	QUOTE_REFERRED: 'QUOTE_REFERRED',
	QUOTE_NOT_FOUND: 'QUOTE_NOT_FOUND',
	QUOTE_EXPIRED: 'QUOTE_EXPIRED',
	QUOTE_ALREADY_TAKEN_UP: 'QUOTE_ALREADY_TAKEN_UP',
	PAYMENT_FAILED: 'PAYMENT_FAILED',
	PAYMENT_DECLINED: 'PAYMENT_DECLINED',
	PAYMENT_TOKEN_ALREADY_USED: 'PAYMENT_TOKEN_ALREADY_USED',
	PAYMENT_3DS_NOT_SUPPORTED_FOR_PROVIDER: 'PAYMENT_3DS_NOT_SUPPORTED_FOR_PROVIDER',
	PAYMENT_INSUFFICIENT_FUNDS: 'PAYMENT_INSUFFICIENT_FUNDS',
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];

export interface ErrorWithCodeResponse {
	errorCode: ErrorCode;
	type: string | null;
	title: string;
	status: number;
	detail: string | null;
	instance: string | null;
	extensions: object;
}

interface ErrorWithCode {
	response: ErrorWithCodeResponse;
}

export function hasErrorCode(error: unknown): error is ErrorWithCode {
	return (
		typeof error === 'object' &&
		error !== null &&
		'response' in error &&
		typeof (error as { [key: string]: unknown }).response === 'object' &&
		error.response !== null &&
		'errorCode' in (error as { response: { [key: string]: unknown } }).response &&
		typeof (error as { response: { errorCode: unknown } }).response.errorCode === 'string'
	);
}
